var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0769 3.19638C26.0615 3.7132 25.0462 3.88547 23.8615 4.05774C25.0462 3.36866 25.8923 2.33502 26.2308 0.956848C25.2154 1.64594 24.0308 1.99048 22.6769 2.33502C21.6615 1.30139 20.1385 0.612305 18.6154 0.612305C15.0615 0.612305 12.3538 4.05774 13.2 7.50318C8.63077 7.33091 4.56923 5.09138 1.69231 1.64594C0.169231 4.23002 1.01538 7.50318 3.38462 9.2259C2.53846 9.2259 1.69231 8.88136 0.846154 8.53681C0.846154 11.1209 2.70769 13.5327 5.24615 14.2218C4.4 14.3941 3.55385 14.5663 2.70769 14.3941C3.38462 16.6336 5.41538 18.3563 7.95385 18.3563C5.92308 19.9068 2.87692 20.7681 0 20.4236C2.53846 21.974 5.41538 23.0077 8.46154 23.0077C18.7846 23.0077 24.5385 14.2218 24.2 6.12501C25.3846 5.43592 26.4 4.40229 27.0769 3.19638Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d4e187cf267cd03d0a6de1d6cf6f16fe.svg";
export { ForwardRef as ReactComponent };